import { useCallback } from 'react';

import { usePopupActions } from '../../store';

export const useHandlers = () => {
  const popupActions = usePopupActions();

  const handleChange = useCallback(
    (id) => {
      popupActions.selectTaxonomy(id);
    },
    [popupActions]
  );

  return {
    handleChange,
  };
};
